import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import UnkwonIcon from '@material-ui/icons/Help'
import { getTableIcon } from 'utils/iconMatcher'
import Avatar from '@material-ui/core/Avatar'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import ReceiptIcon from '@material-ui/icons/Receipt'
import BarIcon from '@material-ui/icons/LocalBar'
import SwapIcon from '@material-ui/icons/SwapHoriz'
import DeleteIcon from '@material-ui/icons/DeleteSweep'
import TicketPrintForm from 'components/hiboutikForms/TicketPrintForm'
import ShowSaleForm from 'components/hiboutikForms/ShowSaleForm'
import Grid from '@material-ui/core/Grid'
import * as Colors from '@material-ui/core/colors'
import CardHeader from '@material-ui/core/CardHeader'
import Card from '@material-ui/core/Card'
import { MODAL_CLIENT_PAYMENT_HISTORY } from 'redux/modules/modals'
const transfertColor = Colors.orange['500']
const styles = theme => ({
  container: {
    marginLeft: '20px',
    marginRight: '20px'
  },
  avatarNormal: {
    backgroundColor: theme.palette.primary.main
  },
  avatarTransfert: {
    backgroundColor: transfertColor
  },
  avatarCancel: {
    backgroundColor: theme.palette.secondary.main
  },
  actionItem: {
    marginRight: 10,
    marginTop: 12
  }
})
class SingleHistoryComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    showModal: PropTypes.func.isRequired,
    style: PropTypes.object
  }
  static defaultProps = {}
  handlePaymentClick = e => {
    if (!(this.props.history || {}).transaction) return
    this.props.showModal(MODAL_CLIENT_PAYMENT_HISTORY, this.props.history)
  }
  getActions = (classes, history) => {
    return (
      <Grid
        className={classes.actionContainer}
        container
        direction="row"
        justify="center"
        alignItems="center">
        {!(history.transaction.canceled || history.transaction.transfertTo) && (
          <Grid item>
            <Button
              className={classes.actionItem}
              onClick={this.handlePaymentClick}
              variant="raised"
              color="primary">
              <ReceiptIcon color="inherit" />
            </Button>
          </Grid>
        )}
        {!(history.transaction.canceled || history.transaction.transfertTo) && (
          <Grid item>
            <TicketPrintForm
              className={classes.actionItem}
              saleId={history.transaction.sale_id}
            />
          </Grid>
        )}
        <Grid item>
          <ShowSaleForm
            className={classes.actionItem}
            saleId={history.transaction.sale_id}
          />
        </Grid>
      </Grid>
    )
  }
  render() {
    const { classes, history } = this.props
    const style = {
      ...this.props.style,
      ...styles.container
    }
    let title = ''
    let icon = <UnkwonIcon color="inherit" />
    let avatarClass = classes.avatarNormal
    if (history.transaction.transfertTo) {
      let name = ''
      if (history.transaction.type === 'POOL') {
        name = history.transaction.pool.table.name
      } else if (history.transaction.type === 'BAR') {
        name = history.transaction.bar.name
      }
      title = `${name} - Transféré`
      icon = <SwapIcon color="inherit" />
      avatarClass = classes.avatarTransfert
    } else if (history.transaction.canceled) {
      let name = ''
      if (history.transaction.type === 'POOL') {
        name = history.transaction.pool.table.name
      } else if (history.transaction.type === 'BAR') {
        name = history.transaction.bar.name
      }
      title = `${name} - Annulé`
      icon = <DeleteIcon color="inherit" />
      avatarClass = classes.avatarCancel
    } else if (history.transaction.type === 'POOL') {
      title = history.transaction.pool.table.name
      icon = getTableIcon(history.transaction.pool.table.type)
    } else if (history.transaction.type === 'BAR') {
      title = history.transaction.bar.name
      icon = <BarIcon color="inherit" />
    }
    title += ` - Total : ${Number(history.transaction.total).toFixed(2)} € `
    return (
      <Card style={style}>
        <CardHeader
          title={title}
          subheader={`${moment(history.transaction.updatedAt).format(
            'DD/MM - HH:mm'
          )}
          -  Vente Hiboutik : ${history.transaction.sale_id}`}
          avatar={
            <Avatar aria-label="type" className={avatarClass}>
              {icon}
            </Avatar>
          }
          action={this.getActions(classes, history)}
        />
      </Card>
    )
  }
}
export default withStyles(styles)(SingleHistoryComponent)



// WEBPACK FOOTER //
// ./src/routes/History/components/SingleHistoryComponent.js